import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useConfirm } from '@/composables/useConfirm'

import {
  lpPasswordSetResource,
} from '@/services/lps.service'
  
import useGlobal from '@/composables/useGlobal'



export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordGenerateModal',
  props: ['info'],
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const form = ref({
  password: '',
  id: '',
  name: '',
})

watch(() => props.info, () => {
  Object.keys(form.value).forEach(key => {
    if(props.info[key]) form.value[key] = props.info[key]
  })
}, {immediate: true, deep: true})

const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const nonFieldErrors = ref("")

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const send = async (sendData: any, control: any) => {
  const question = $t('Сonfirm action')
  const preparedData = {
    password: form.value.password,
    lp: form.value.id,
  }
  try {
    await useConfirm(question)
    load.value = true
    await lpPasswordSetResource.execute({}, {
      ...preparedData,
    })
    dataIsSended.value = true
    load.value = false
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { props, form, emit, $t, load, dataIsSended, nonFieldErrors, request, send, ref, computed, watch, get useSubmit() { return useSubmit }, get useConfirm() { return useConfirm }, get lpPasswordSetResource() { return lpPasswordSetResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})